import { InterestAction } from "@/modules/lead-page/types";
import { Box } from "@mui/material";
import { format, parseISO } from "date-fns";
import CommonAvatar from "@/modules/common/components/ui-kit/common-avatar";
import { Settings } from "lucide-react";

export default function InterestActionInfo({
  interestAction,
}: {
  interestAction: InterestAction;
}) {
  return (
    <Box
      sx={(t) => ({
        display: "inline-flex",
        alignItems: "baseline",
        gap: t.nawy.spacing.xxs,
        color: t.nawy.colors.semantic.text.tertiary,
        ...t.nawy.typography.english.variants.body.sm.regular,
      })}
    >
      {interestAction.addedBy ? (
        <CommonAvatar
          name={interestAction.addedBy.name ?? ""}
          color={interestAction.addedBy.color}
        />
      ) : (
        <CommonAvatar icon={<Settings size={16} />} />
      )}{" "}
      {"added by"}{" "}
      {interestAction.addedBy ? interestAction.addedBy.name ?? "" : "system"}
      {" on "}
      {format(parseISO(interestAction.createdAt), "d MMM yyyy")}
    </Box>
  );
}
